import { Box, Typography } from "@mui/material";

const linkSx = {
  position: "relative",
  display: "inline-block",
  "::after": {
    content: '""',
    display: { xs: "none", md: "block" },
    position: "absolute",
    left: 0,
    right: 0,
    height: "3px",
    backgroundColor: "currentColor",
    bottom: "-10px",
    opacity: 0,
    transform: "scaleX(0.7)",
    transition: "none",
  },
  "&:hover::after": {
    opacity: { xs: 0, md: 1 },
    transform: { xs: "scaleX(0.7)", md: "scaleX(1)" },
  },
};

function ContactLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  const isExternal = href.startsWith("http");
  return (
    <a
      href={href}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      style={{ textDecoration: "none" }}
    >
      <Typography variant="h4" lineHeight={1.2} fontWeight={400} sx={linkSx}>
        {children}
      </Typography>
    </a>
  );
}

export default function Contact() {
  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ overflow: "auto" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        justifyContent={"center"}
        height={"100%"}
        gap={4}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={{ xs: 0, md: 2 }}
          flexWrap="wrap"
          justifyContent="center"
          px={2}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <ContactLink href="mailto:theo.greenslade@gmail.com">
            EMAIL
          </ContactLink>
          <Typography
            variant="h4"
            lineHeight={1.2}
            fontWeight={400}
            sx={{ display: { xs: "none", md: "block" }, color: "#ffffff" }}
          >
            /
          </Typography>
          <ContactLink href="https://www.linkedin.com/in/theogreenslade/">
            LINKEDIN
          </ContactLink>
          <Typography
            variant="h4"
            lineHeight={1.2}
            fontWeight={400}
            sx={{ display: { xs: "none", md: "block" }, color: "#ffffff" }}
          >
            /
          </Typography>
          <ContactLink href="https://github.com/TheoGreenslade">
            GITHUB
          </ContactLink>
        </Box>
      </Box>
    </Box>
  );
}
